import { render, staticRenderFns } from "./ViewZoom.vue?vue&type=template&id=8b7dff22&scoped=true&"
import script from "./ViewZoom.vue?vue&type=script&lang=js&"
export * from "./ViewZoom.vue?vue&type=script&lang=js&"
import style0 from "./ViewZoom.vue?vue&type=style&index=0&id=8b7dff22&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7dff22",
  null
  
)

export default component.exports